<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <CollectionList></CollectionList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Collections",
  data: () => ({
    page: {
      title: "Collections"
    },
    elementVisible: false,
    breadcrumbs: [
      {
        text: "Collections",
        disabled: true
      }
    ]
  }),
  components: {
    CollectionList: () => import("../components/CollectionList")
  }
};
</script>
